import React from 'react'
import './PageTitle.css'
import cn from 'classnames'

class PageTitle extends React.Component<any, any> {
  render() {
    const { className, title, ctdetails, testId, ...otherProps } = this.props

    const classNames = cn('PageTitle', className)

    return (
      <div className={classNames} {...otherProps} data-test-id={testId || 'cs-page-title'}>
        {title}
        {ctdetails && ctdetails()}
      </div>
    )
  }
}

export default PageTitle
